module.exports = __webpack_public_path__ + "img/q3.f61045c6.jpg";